// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ServerMessaeSide } from './ServerMessageSide';
// public static Action<ServerMessaeContainer> ServerMessage;
export class ServerMessaeContainer {
    constructor() {
        /// <summary>
        /// /дэйт-тайм мессаджа
        /// </summary>
        this.dateTime = null;
        /// <summary>
        /// /айди (код) мессаджа
        /// </summary>
        this.MessageCode = null;
        this.MessageName = '';
        /// <summary>
        /// Содержимое мессаджа
        /// </summary>
        this.Text = '';
        /// <summary>
        /// Содержимое мессаджа в читаемом виде
        /// </summary>
        this.TextNew = null;
        /// <summary>
        /// Содержимое мессаджа в читаемом виде
        /// </summary>
        this.DataForTreeView = null;
        /// <summary>
        /// Адрес ноды подключения (для кластера)
        /// </summary>
        this.NodeAddress = '';
        this.Side = ServerMessaeSide.Input;
        this.Length = null;
        this.Mode = null;
        this.StringMode = '';
        /// <summary>
        /// Сессия (айди подключения)
        /// Может быть пустой (пока сервер не подключил меня)
        /// </summary>
        this.Session = '';
        this.IsOutgoingMSG = null;
    }
}
